// extracted by mini-css-extract-plugin
export default {"searchAndClaimPage":"PropertiesSearchAndClaim_searchAndClaimPage__BQYfr","claimButton":"PropertiesSearchAndClaim_claimButton__52LUz"};